/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PermissionResource {
  MEMBER_MANAGEMENT = 'member_management',
  WORKSPACE_MANAGEMENT = 'workspace_management',
  PAYMENT_MANAGEMENT = 'payment_management',
  VIEW_ALL_MEETINGS = 'view_all_meetings',
  VIEW_ALL_TEAM_MEETINGS = 'view_all_team_meetings',
  DELETE_MEETINGS_FROM_WORKSPACE = 'delete_meetings_from_workspace',
  ALL_ARCHIVE_MEETINGS = 'all_archive_meetings',
  ARCHIVE_MEETINGS = 'archive_meetings',
  TEAM_MANAGEMENT = 'team_management',
  TEAM_MEMBER_MANAGEMENT = 'team_member_management',
  DELETE_MEETINGS_FROM_TEAM = 'delete_meetings_from_team',
  EDIT_MEETING_VIEW_SCOPE = 'edit_meeting_view_scope',
  ALL_EDIT_MEETING_PROPERTIES = 'all_edit_meeting_properties',
  EDIT_MEETING_PROPERTIES = 'edit_meeting_properties',
  ALL_EXTERNAL_MEETING_SHARING = 'all_external_meeting_sharing',
  EXTERNAL_MEETING_SHARING = 'external_meeting_sharing',
  RESET_LANGUAGE = 'reset_language',
  AUTOMATION_INTEGRATION = 'automation_integration',
  ALL_SHARE_INTEGRATION = 'all_share_integration',
  SHARE_INTEGRATION = 'share_integration',
  WORKSPACE_INTEGRATION = 'workspace_integration',
  VIEW_MEETINGS = 'view_meetings',
  CHATBOT_FEATURES = 'chatbot_features',
}
